import { Divider, Flex, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import Heading from '@/components/Typography/Heading';
import type { TOPIC_2_TYPE } from '@/types/taxonomyConst';

import S from './styles';
import type { EditTopicModalProps } from './types';
import TopicCard from './UpperLevelDisplay/TopicCard';
import UpperLevelDisplay from './UpperLevelDisplay/UpperLevelDisplay';

const ViewSetting = (
  props: EditTopicModalProps & {
    initialTopic: Topic2T<TOPIC_2_TYPE>;
    target: CreateTopicTarget;
    targetAlias?: string;
    onEditClick?: () => void;
    closeModal: () => void;
  },
) => {
  return (
    <S.MainLayout>
      <VFlex className="header">
        <Heading type="h2">View settings</Heading>
      </VFlex>
      <Divider />
      <VFlex className="body" g={16}>
        <UpperLevelDisplay
          target={props.target}
          targetTopicAlias={props.targetAlias}
          taxonomyAlias={props.taxonomyAlias}
        />
        <TopicCard topic={props.initialTopic} indent={0} />
      </VFlex>
      <Divider />
      <Flex className="footer" j="flex-end">
        <Button variant="ghost" sizeType="xl" onClick={props.closeModal}>
          Close
        </Button>
        {props.onEditClick && (
          <Button variant="outlined" sizeType="xl" onClick={props.onEditClick}>
            Edit
          </Button>
        )}
      </Flex>
    </S.MainLayout>
  );
};

export default ViewSetting;
